import {
  Modal,
  Form,
  Input,
  Button,
  Divider,
  Typography,
  Spin,
  Tooltip,
} from "antd";
import "./style.scss";
import showConfirm from "../../../../components/ExitConfirm/ExitConfirm";
import TrackingDetails from "./TrackingDetails";
import { useEffect, useState } from "react";
import { httpService } from "../../../../../services/httpService.service";
import moment from "moment";
import cancelX from "../../../../../Assets/svg/cancelXbutton.svg";
import Done from "../../../../../Assets/svg/done.svg";
import ExclamationMark from "../../../../../Assets/svg/exclamationMark.svg";
import dayjs from "dayjs";
import Preview from "../TableView/modals/Preview";
import { FiEdit2 } from "react-icons/fi";
import { EyeOutlined } from "@ant-design/icons";
import EditSiteVisitCardModal from "./EditSiteVisitCardModal";
import { isAuthorized } from "../../../../../services/authService";
import { RolesEnum } from "../../../../../services/rolesEnum";

const TrackingModal = ({
  visible,
  onCancel,
  onOk,
  siteVisitCardId,
  tracked,
  setMessage,
  fetchSiteVisitCards,
}) => {
  const [form] = Form.useForm();
  const [submitLoader, setSubmitLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enumerators, setEnumerators] = useState([]);
  const [showVisitDetails, setShowVisitDetails] = useState(false);
  const [showEditVisitDetails, setEditVisitDetails] = useState(false);
  const [siteVisitId, setSiteVisitId] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [siteVisitStatus, setSiteVisitStatus] = useState(null);
  const [treningCompleted, setTreningCompleted] = useState(false);
  const [reportingStatusOptions, setReportingStatusOptions] = useState([]);
  const [dateFields, setDateFields] = useState([0, 1]);
  const [requiredReports, setRequiredReports] = useState(2);
  const [showRequiredReports, setShowRequiredReports] = useState(false);

  const handleReportingStatus = (value) => {
    let options = [];
    if (value == 4) {
      options = [{ value: 1, label: "Data collection" }];
    } else if (value == 5) {
      options = [
        { value: 2, label: "Data check" },
        { value: 3, label: "Field report writing" },
        { value: 4, label: "Translation" },
        { value: 5, label: "Field reporting completed" },
        { value: 6, label: "Field report approved" },
      ];
    } else if (value == 6) {
      options = [{ value: 7, label: "Field report submitted to client" }];
    }
    setReportingStatusOptions(options);
  };

  useEffect(() => {
    if (siteVisitCardId && visible) {
      setLoading(true);
      const apiSiteVisitCards = `/api/Site/getSiteVisit?id=${siteVisitCardId}`;

      httpService.get(
        apiSiteVisitCards,
        (res) => {
          setSiteVisitId(res?.data?.id);
          const { team } = res?.data?.logistic || {};
          const { teamLead, enumerators = [] } = team || {};

          const formattedTeamLeader = teamLead
            ? {
                email: `${teamLead.email} - (Team Leader)`,
                firstName: teamLead.firstName,
                enumeratorId: teamLead.id,
                lastName: `${teamLead.lastName} - (Team Leader)`,
                position: teamLead.position,
              }
            : null;

          const formattedEnumerators = enumerators.map(
            ({ email, firstName, id, lastName, position }) => ({
              email,
              firstName,
              enumeratorId: id,
              lastName,
              position,
            })
          );

          const enumeratorsData = formattedTeamLeader
            ? [formattedTeamLeader, ...formattedEnumerators]
            : formattedEnumerators;
          if (!tracked) {
            setEnumerators(enumeratorsData);
            const siteVisitStatus = res?.data?.siteVisitStatus;
            const treningCompleted = res?.data?.tracking?.trainingIsCompleted;
            siteVisitStatus == 5
              ? setSiteVisitStatus(5)
              : setSiteVisitStatus(null);
            treningCompleted == true
              ? setTreningCompleted(true)
              : setTreningCompleted(false);
          }

          if (tracked) {
            setTrackingId(res?.data?.tracking?.id);
            const enumeratorTrackData = res?.data?.tracking?.enumerators;
            setEnumerators(enumeratorTrackData);
            const enumeratorsProgress = enumeratorTrackData.reduce(
              (acc, enumerator, index) => {
                acc[`trainingScore-${index}`] = enumerator?.trainingScore || "";
                acc[`percentageCompleted-${index}`] =
                  enumerator?.percentageCompleted || "";
                return acc;
              },
              {}
            );

            const trackingReports = res?.data?.tracking?.trackingReports.reduce(
              (acc, report, index) => {
                acc[`report${index + 1}`] =
                  report?.reportName || "no report name";
                acc[`makeReportRequired${index + 1}`] =
                  report?.isRequired || false;
                return acc;
              },
              {}
            );

            const siteVisitStatus = res?.data?.siteVisitStatus;
            const treningCompleted = res?.data?.tracking?.trainingIsCompleted;
            handleReportingStatus(siteVisitStatus);

            const trainingDates = res?.data?.tracking?.trainingDates || [];

            const trainingDateFieldValues = trainingDates.reduce(
              (acc, item, index) => {
                acc[`trainingDate${index}`] = item?.date
                  ? dayjs(item.date, "YYYY-MM-DDTHH:mm:ss")
                  : null;
                return acc;
              },
              {}
            );

            const visitDates =
              res?.data?.tracking?.siteTrackingVisitDates || [];

            const actualDateOfVisits = visitDates.map((item) =>
              item?.visitDate
                ? dayjs(item.visitDate, "YYYY-MM-DDTHH:mm:ss")
                : null
            );
            setShowRequiredReports(
              res?.data?.tracking?.trackingReports?.length
            );

            console.log(res.data.tracking.siteTrackingVisitDates);

            const initialData = {
              addRequiredReports: res?.data?.tracking?.trackingReports?.length,
              ...enumeratorsProgress,
              ...trackingReports,
              identifier: res?.data?.identifier,
              dateOfReport: dayjs(res?.data?.tracking?.dateOfReport),
              dateOfDebrief: dayjs(res?.data?.tracking?.dateOfDebrief),
              fieldTeamReportingStatus:
                res?.data?.tracking?.fieldTeamReportingStatus,
              percentageOfDataCollectionCompleted:
                res?.data?.tracking?.percentageOfDataCollectionCompleted,
              reportingMonth: res?.data?.tracking?.reportingMonth,
              reportingYear: res?.data?.tracking?.reportingYear,
              siteVisitStatus: siteVisitStatus,
              ...trainingDateFieldValues,
              actualDateOfVisits: actualDateOfVisits,
              trainingIsCompleted: treningCompleted,
              trainingScoreInfo: res?.data?.tracking?.trainingScoreInfo,
            };

            if (trainingDates?.length) {
              setDateFields(trainingDates.map((_, index) => index));
            }
            siteVisitStatus == 5
              ? setSiteVisitStatus(5)
              : setSiteVisitStatus(null);
            treningCompleted == true
              ? setTreningCompleted(true)
              : setTreningCompleted(false);

            form.setFieldsValue(initialData);
          } else {
            const initialData = {
              identifier: res?.data?.identifier,
            };
            form.setFieldsValue(initialData);
          }

          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      );
    }
  }, [visible]);

  const closeModal = () => {
    showConfirm(handleLeave, handleReturn);
  };

  const handleLeave = () => {
    form.resetFields();
    if (!tracked) {
      setShowRequiredReports(false);
      setRequiredReports(2);
    }
    onCancel();
  };

  const handleReturn = () => {
    // console.log("Cancel action");
  };

  const formatDate = (date, type) => {
    if (!date?.$isDayjsObject) return "";

    if (type) {
      const newDate = new Date(date);
      const formattedDate = moment(
        new Date(newDate.setDate(newDate.getDate() - 1))
      );
      return formattedDate.format("YYYY-MM-DD HH:mm:ss");
    } else {
      const formattedDate = date.format("YYYY-MM-DD HH:mm:ss");
      return formattedDate;
    }
  };

  const handleSubmit = () => {
    setSubmitLoader(true);
    form
      .validateFields()
      .then((values) => {
        const trainingDates = dateFields.map((field) =>
          formatDate(values[`trainingDate${field}`])
        );
        const actualDateOfVisits = values.actualDateOfVisits.map(formatDate);

        // const actualDateOfVisit = formatDate(values.actualDateOfVisit);
        const dateOfReport = formatDate(values.dateOfReport);
        const dateOfDebrief = formatDate(values.dateOfDebrief);

        const formData = new FormData();

        if (tracked) {
          const trackingReports = Object.keys(values)
            .filter(
              (key) =>
                key.startsWith("report") &&
                !key.includes("makeReportRequired") &&
                !key.startsWith("reporting")
            )
            .map((key) => {
              const index = key.replace("report", "");
              return {
                reportName: values[key],
                isRequired: values[`makeReportRequired${index}`] || false,
              };
            });

          const data = {
            id: trackingId,
            reportingYear: values.reportingYear,
            reportingMonth: values.reportingMonth,
            trainingDates: trainingDates,
            trainingScoreInfo: "string",
            actualDateOfVisits: actualDateOfVisits,
            dateOfReport: dateOfReport,
            dateOfDebrief: dateOfDebrief,
            percentageOfDataCollectionCompleted: 0,
            siteVisitStatus: values?.siteVisitStatus,
            fieldTeamReportingStatus: values?.fieldTeamReportingStatus,
            trainingIsCompleted: values.trainingIsCompleted || false,
            enumerators: enumerators?.map((enumerator) => ({
              enumeratorId: enumerator?.enumeratorId,
              ...(enumerator?.trainingScore
                ? { trainingScore: enumerator?.trainingScore }
                : {}),
              ...(enumerator?.percentageCompleted
                ? { percentageCompleted: enumerator?.percentageCompleted }
                : {}),
            })),
            trackingReports,
          };

          httpService.put(
            "/api/Site/updateTracking",
            data,
            (res) => {
              setMessage({
                trigger: true,
                type: "success",
                icon: Done,
                title: `Tracking of site visit updated successfully!`,
                text:
                  res?.message ||
                  "You have successfully updated tracking in site visit",
              });
              setTimeout(() => setMessage({ trigger: false }), 3000);
              setSubmitLoader(false);
              form.resetFields();
              onOk();
            },
            (error) => {
              handleError(error, "Failed to update tracking for site visit.");
            }
          );
        } else {
          formData.append("siteVisitId", siteVisitCardId);
          formData.append("reportingYear", values.reportingYear);
          formData.append("reportingMonth", values.reportingMonth);

          // Append each training date separately to FormData
          trainingDates?.forEach((date, index) => {
            formData.append(`trainingDates[${index}]`, date);
          });

          actualDateOfVisits?.forEach((date, index) => {
            formData.append(`actualDateOfVisits[${index}]`, date);
          });

          formData.append("dateOfReport", dateOfReport);
          formData.append("dateOfDebrief", dateOfDebrief);
          formData.append("siteVisitStatus", values?.siteVisitStatus);
          formData.append(
            "fieldTeamReportingStatus",
            values?.fieldTeamReportingStatus
          );
          formData.append(
            "trainingIsCompleted",
            values.trainingIsCompleted || false
          );

          enumerators?.forEach((enumerator, index) => {
            formData.append(
              `enumerators[${index}].enumeratorId`,
              enumerator?.enumeratorId
            );
            if (enumerator?.trainingScore) {
              formData.append(
                `enumerators[${index}].trainingScore`,
                enumerator?.trainingScore
              );
            }
            if (enumerator?.percentageCompleted != null) {
              formData.append(
                `enumerators[${index}].percentageCompleted`,
                enumerator.percentageCompleted
              );
            }
          });

          Array.from({ length: requiredReports }, (_, index) => {
            formData.append(
              `trackingReport[${index}].reportName`,
              values[`report${index + 1}`]
            );
            formData.append(
              `trackingReport[${index}].isRequired`,
              values[`makeReportRequired${index + 1}`] ? "true" : "false"
            );
          });

          httpService.post(
            "/api/Site/createTracking",
            formData,
            (res) => {
              setMessage({
                trigger: true,
                type: "success",
                icon: Done,
                title: `Tracking of site visit created successfully!`,
                text: res.message || "You have successfully tracked site visit",
              });
              setTimeout(() => setMessage({ trigger: false }), 3000);
              setSubmitLoader(false);
              form.resetFields();
              onOk();
            },
            (error) => {
              handleError(error, "Failed to create tracking for site visit.");
            }
          );
        }
      })
      .catch((errorInfo) => {
        setSubmitLoader(false);
        scrollToField(errorInfo);
        setMessage({
          trigger: true,
          type: "danger",
          icon: ExclamationMark,
          title: "Oops! A problem has occurred!",
          text:
            errorInfo.errorFields?.length > 0
              ? "Please fill all the required fields."
              : "An unexpected error occurred.",
        });
        setTimeout(() => setMessage({ trigger: false }), 3000);
      });
  };

  const handleError = (error, defaultMessage) => {
    setMessage({
      trigger: true,
      type: "danger",
      icon: ExclamationMark,
      title: "Update Failed",
      text: error?.errors?.[0]?.message || error?.message || defaultMessage,
    });
    setTimeout(() => setMessage({ trigger: false }), 3000);
    setSubmitLoader(false);
  };

  const scrollToField = (errorInfo) => {
    const firstErrorField = errorInfo?.errorFields[0];
    if (firstErrorField) {
      form.scrollToField(firstErrorField?.name[0], {
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <Modal
      title={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src={cancelX}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={closeModal}
              alt="cancelX"
            />
          </div>
          <h2 className="modalHeader">Site visit card</h2>
        </>
      }
      closable={false}
      open={visible}
      onCancel={closeModal}
      width={800}
      footer={[
        <Button key="back" onClick={closeModal} className="inviteButtonTPM">
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          className="addButtonTPM"
          loading={submitLoader}
        >
          {tracked ? `Edit Tracking` : `Add Tracking`}
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            actualDateOfVisits: [null],
          }}
        >
          <div className="d-flex justify-content-between align-items-center gap-4 w-100">
            <div className="indentifierTracking w-100">
              <Form.Item
                className="w-100"
                label="Site Visit Card Identifier"
                name="identifier"
              >
                <Input disabled />
              </Form.Item>
            </div>

            <Preview
              visible={showVisitDetails}
              onClose={() => setShowVisitDetails(false)}
              siteVisitCardId={siteVisitId}
            />
            <EditSiteVisitCardModal
              onOk={() => {
                fetchSiteVisitCards();
                setEditVisitDetails(false);
              }}
              visible={showEditVisitDetails}
              onCancel={() => setEditVisitDetails(false)}
              siteVisitCardId={siteVisitId}
              setMessage={setMessage}
            />
            <div className="d-flex flex-row align-items-center justify-content-between gap-2">
              <Tooltip title="Preview">
                <Button
                  className="btnSeeSiteDetails d-flex justify-content-center"
                  onClick={() => setShowVisitDetails(true)}
                  icon={<EyeOutlined />}
                />
              </Tooltip>
              {isAuthorized([RolesEnum.SystemAdmin]) && (
                <Tooltip title="Edit">
                  <Button
                    className="btnSeeSiteDetails d-flex justify-content-center"
                    onClick={() => setEditVisitDetails(true)}
                    icon={<FiEdit2 />}
                  />
                </Tooltip>
              )}
            </div>
          </div>
          <Divider />
          <h3 className="m-0 mb-4 p-0">Tracking</h3>
          <TrackingDetails
            form={form}
            enumerators={enumerators}
            setEnumerators={setEnumerators}
            siteVisitStatus={siteVisitStatus}
            setSiteVisitStatus={setSiteVisitStatus}
            treningCompleted={treningCompleted}
            setTreningCompleted={setTreningCompleted}
            reportingStatusOptions={reportingStatusOptions}
            setReportingStatusOptions={setReportingStatusOptions}
            dateFields={dateFields}
            setDateFields={setDateFields}
            requiredReports={requiredReports}
            setRequiredReports={setRequiredReports}
            showRequiredReports={showRequiredReports}
            setShowRequiredReports={setShowRequiredReports}
          />
          <Divider />
        </Form>
      </Spin>
    </Modal>
  );
};
export default TrackingModal;
